import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export default styled.div`
  height: 60px;
  background-color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${zIndexTypes.topNavBar};
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet`
    &.downScroll {
      top: -60px;
    }
  `}
`;
